var map = {
	"./abstract": "gskv",
	"./abstract.js": "gskv",
	"./link": "RBOx",
	"./link.js": "RBOx",
	"./quote": "chdl",
	"./quote.js": "chdl",
	"./text": "4kjP",
	"./text.js": "4kjP",
	"./video": "qsJq",
	"./video-group": "BBr0",
	"./video-group.js": "BBr0",
	"./video-slider": "VbhK",
	"./video-slider.js": "VbhK",
	"./video.js": "qsJq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5OEO";


//////////////////
// WEBPACK FOOTER
// ./src/models/sections ^\.\/.*$
// module id = 5OEO
// module chunks = 7